export enum Key {
    Enter = 'Enter',
    NumpadEnter = 'NumpadEnter',
    Escape = 'Escape',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    ArrowUp = 'ArrowUp',
    ArrowDown = 'ArrowDown',
    Meta = 'Meta',
    Backspace = 'Backspace',
    Delete = 'Delete',
    Tab = 'Tab',
}

export default Key;
